const DEFAULT_INVITE_CODE = 'MLPQDT8081'

export default DEFAULT_INVITE_CODE
